<template>
  <div :class="{fadeIn: openModal, fadeOut: !openModal}"
       class="modal-mask animated"
       @keydown.esc="closeModal">
    <div id="modalTemplate"
         ref="modal-template"
         :class="{fadeInDown: openModal, fadeOutUp: !openModal, small: size === 'small', intermedium: size === 'intermedium','intermedium-large': size === 'intermedium-large',normal: size === 'normal', large: size === 'large', posR: !title}"
         class="modal-template animated fadeInDown">
      <span v-if="(!title && !isStatic && close)"
            class="close-arrow"
            :class="{'left': closePosition === 'left'}"
            @click="closeModal" />
      <div v-else-if="title"
           class="modal-template-header">
        <h3>{{ title }}</h3>
        <span class="close-arrow"
              :class="{'left': closePosition === 'left'}"
              @click="closeModal" />
        <slot name="header" />
      </div>
      <div class="modal-template-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'normal'
    },
    isStatic: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: true
    },
    closePosition: {
      type: String,
      default: 'right'
    }
  },
  data: () => ({
    openModal: true
  }),
  mounted() {
    window.addEventListener('keyup', this.handleEsc)
  },
  destroyed() {
    window.removeEventListener('keyup', this.handleEsc)
  },
  methods: {
    closeModal: function() {
      this.openModal = false
      setTimeout(() => {
        this.$emit('close')
      }, 1000)
    },
    handleEsc(e) {
      if (e.keyCode === 27 && this.openModal) this.closeModal()
    }
  }
}
</script>

<style lang="scss">
@import './modal-template.sass';
</style>
